export default {
  notifications: {
    loadError: "Failed to load notifications",
    bell: {
      aria: "Notifications",
      unreadAria: "Notifications, {{count}} unread",
    },
    popover: {
      title: "Notifications",
      unreadSummary_one: "{{count}} unread",
      unreadSummary_other: "{{count}} unread",
      allRead: "You’re all caught up",
      empty: "No notifications yet",
      markAllRead: "Mark all as read",
      showAll: "Show all",
    },
    sidebar: {
      item: "Notifications",
      itemUnreadAria: "Notifications, {{count}} unread",
    },
    item: {
      unreadAria: "Unread notification: {{title}}",
      markReadAria: "Mark as read: {{title}}",
    },
    toast: {
      aggregated_one: "You have {{count}} new notification",
      aggregated_other: "You have {{count}} new notifications",
    },
    page: {
      title: "Notifications",
      subtitle: "History of events and reminders from the portal.",
      tabsAria: "Notification sections",
      modeGroupAria: "Read-status filter",
      tabs: {
        feed: "Feed",
        settings: "Settings",
      },
      filters: {
        all: "All",
        unread: "Unread",
        type: "Notification type",
        typeAll: "All types",
        fromDate: "From date",
        fromDateAria: "Pick the start date",
        reset: "Reset filters",
      },
      bulk: {
        selectAll: "Select all on page",
        selectOne: "Select “{{title}}”",
        selectedCount_one: "{{count}} selected",
        selectedCount_other: "{{count}} selected",
        markRead: "Mark as read",
        delete: "Delete",
      },
      pageRange: "{{from}}–{{to}} of {{total}}",
      pageIndicator: "Page {{current}} of {{total}}",
      prev: "Previous",
      next: "Next",
      empty: "No notifications",
      emptyFiltered: "No notifications match the selected filters",
      deleteItem: "Delete notification",
      clearRead: "Clear read",
      clearReadConfirm: "Delete all read notifications? This action can’t be undone.",
      clearReadDo: "Clear",
      clearReadDone: "Read notifications deleted",
      clearReadFailed: "Failed to clear notifications",
    },
    settings: {
      title: "Notification channels",
      subtitle: "Choose where to send each notification type.",
      perTypeSectionTitle: "Per-type preferences",
      perTypeSectionHint: "Changes save as soon as you flip a switch.",
      inAppDescription: "The in-portal feed and bell in your account.",
      emailDescription: "A copy sent to the address on your profile.",
      groupEvents: "Events",
      groupDeposits: "Deposits",
      groupOther: "Other",
      typeHeader: "Notification type",
      inAppHeader: "In-app",
      emailHeader: "Email",
      loadError: "Failed to load settings",
      updateFailed: "Failed to save changes",
      empty: "No notification types available",
      toggleInAppAria: "In-app notifications: {{type}}",
      toggleEmailAria: "Email notifications: {{type}}",
    },
    type: {
      "deposit.status_changed": "Deposit status",
      "event.registration_registered": "Event registration",
      "event.registration_pending": "Event participation: registration pending confirmation",
      "event.registration_approved": "Event participation: registration approved",
      "event.registration_rejected": "Event participation: registration rejected",
    },
  },
  toast: {
    regionAria: "System notifications",
    close: "Dismiss notification",
  },
}
